import {useSelector} from 'react-redux'
import {State} from '../../../../reducers'
import {esNormativaV2} from '../../../../utils/normativa.utils'

interface PropiedadesDetalleDistritoV2 {
  valor?: any
  etiqueta?: string
  usarEmisor?: boolean
}

export default function DetalleDistritoV2({
  valor,
  etiqueta,
  usarEmisor,
}: PropiedadesDetalleDistritoV2) {
  const {datosEmisor} = useSelector((state: State) => state.catalogos)

  if (!esNormativaV2(datosEmisor)) return null

  const texto = usarEmisor
    ? `${datosEmisor?.distritonombre ?? datosEmisor?.distrito ?? ''}`.trim()
    : `${valor ?? ''}`.trim()

  if (!texto) return null

  return (
    <div className='detail'>
      <label>{etiqueta ?? 'Distrito:'}</label>
      <label>{texto.toUpperCase()}</label>
    </div>
  )
}
